import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { IVideo } from '../../types/developer/video';
import { VideoSection as VideoSectionComponent } from '../../components/VideoSection';
import { VideoPreview } from '../../components/VideoPreview';
import { getVideos } from '../../selectors';
import { VideoModal } from '../VideoModal';

export function VideoSection() {
  const [currentVideo, setCurrentVideo] = React.useState<IVideo | null>(null);
  const videos = useSelector(getVideos);

  const videoCards = React.useMemo(
    () =>
      videos.map(video => (
        <div
          style={{ width: '356px', height: '250px', position: 'relative', borderRadius: '4px', overflow: 'hidden' }}
          key={video.id}
        >
          <VideoPreview url={video.previewImage} onClick={() => setCurrentVideo(video)} />
        </div>
      )),
    [videos],
  );

  const handleVideoClose = React.useCallback(() => setCurrentVideo(null), []);

  if (!videos || !videos.length) {
    return null;
  }

  return (
    <VideoSectionComponent
      title={<ArticleHeading1>Видео</ArticleHeading1>}
      videos={videoCards}
      modal={
        currentVideo ? (
          <VideoModal
            title={currentVideo.title}
            videoId={currentVideo.videoId}
            onClose={handleVideoClose}
            open={Boolean(currentVideo)}
            videoPreviewUrl={currentVideo.previewImage}
          />
        ) : null
      }
    />
  );
}
